// extracted by mini-css-extract-plugin
module.exports = {"inputField":"ChangePasswordSection_inputField__2B3SC","inputFieldSuccess":"ChangePasswordSection_inputFieldSuccess__UrX3f"};